export default __webpack_public_path__ + "static/media/Drizzle-Cloud.5f79aa8e.png";